import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full p-[6%] gap-5" }
const _hoisted_2 = { class: "flex text-lg font-semibold pb-1" }
const _hoisted_3 = {
  key: 0,
  class: "flex w-full"
}
const _hoisted_4 = { key: 1 }

import { ref } from "vue";
import {
  formOptionsType,
  DividendCreateClass,
} from "@/services/dividends/types";
import { DividendService } from "@/services/dividends/dividendService";
import NewDividendForm from "./NewDividendForm.vue";
import FilterForm from "./FilterForm.vue";
import Swal from "sweetalert2";
import { DividendsFilter } from "@/services/dividends/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'GenericDividendsForm',
  props: {
  formOptionSelected: {
    type: Number,
    required: true,
  },
},
  emits: [
  "closeModals",
  "aplyFilter",
  "getDivident",
  "getAllDividends",
],
  setup(__props, { emit }) {

const props = __props;

NewDividendForm;




const dividendsService = new DividendService();
const loadingForm = ref<boolean>(false);

async function submitNewDividentForm(valuesDividendForm: DividendCreateClass) {
  try {
    loadingForm.value = true;
    const res = await dividendsService.createNewDivident(valuesDividendForm);

    if (res.success) {
      //alert("Se ha registrado el dividendo de manera exitosa");
      loadingForm.value = false;
      Swal.fire(
        "¡Listo!",
        "La información se ha modificado de forma éxitosa",
        "success"
      );
      emit("closeModals");
      emit("getAllDividends", 1);
      loadingForm.value = false;
    }
  } catch (error) {
    console.log(error);
  } finally {
    console.log("entra aca");
  }
}

function submitFilterForm(dividendFilter: DividendsFilter) {
  emit("aplyFilter", dividendFilter);
  emit("closeModals");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", null, [
      _createElementVNode("label", _hoisted_2, _toDisplayString(__props.formOptionSelected == _unref(formOptionsType).newDividendForm
            ? "Crear Nuevo Dividendo"
            : "Filtro"), 1)
    ]),
    (__props.formOptionSelected == _unref(formOptionsType).newDividendForm)
      ? (_openBlock(), _createElementBlock("article", _hoisted_3, [
          _createVNode(NewDividendForm, {
            onSubmitNewDividendData: submitNewDividentForm,
            isLoading: loadingForm.value
          }, null, 8, ["isLoading"])
        ]))
      : _createCommentVNode("", true),
    (__props.formOptionSelected == _unref(formOptionsType).filterForm)
      ? (_openBlock(), _createElementBlock("article", _hoisted_4, [
          _createVNode(FilterForm, { onSubmitFilterData: submitFilterForm })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})